enum FormFields {
  FirstName = 'firstName',
  LastName = 'lastName',
  Email = 'email',
  Role = 'role',
  Properties = 'properties',
  ExcludeFromReports = 'excludeFromReports',
}

const FormFieldsList = [
  FormFields.FirstName,
  FormFields.LastName,
  FormFields.Email,
  FormFields.Role,
  FormFields.Properties,
  FormFields.ExcludeFromReports,
];

export { FormFields, FormFieldsList };
